<template>
  <div class="leaves">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Loans</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Loan</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Request Loan</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- Leave Statistics -->
          <div class="row">
            <div class="col-md-3" v-for="item in loanTypes" :key="item.typeId">
              <div class="stats-info">
                <h6>{{ item.description }}</h6>
                <h5>{{ item.tenor }} Months Maximum</h5>
              </div>
            </div>
          </div>
          <!-- /Leave Statistics -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="loans"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.employee.firstName} ${item.employee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.requestDate`]="{ item }">
                    {{
                      item.toDate
                        ? new Date(item.requestDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditLoan(item)"
                          v-if="
                            item.status == 0 && item.amount != 0 && item.approvedByManager == null
                          "
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <router-link
                        class="dropdown-item"
                        :to="{
                          name: 'loanhistory',
                          params: { id: item.employee.id }
                        }"> View History</router-link>
                        <a class="dropdown-item" @click="onDownload(item)" v-if="(item.loanTypeId == 3 || item.loanTypeId == 4) && item.status == 1"
                          ><i class="fa fa-file-o m-r-5"></i> Download Certificate</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteLoan(item)"
                          v-if="item.approvedByManager == null"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 &&  item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="
                        item.status == 0 &&
                          !item.nextApproval &&
                          !item.approvedBy
                      "
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting HR
                      Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && !item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Payroll Update
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && item.updatedByHCRM"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>

                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
          <!-- /Page Content -->
          <!-- Add Leave Modal -->
          <v-dialog v-model="dialog" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Request Loan</h5>
                <button type="button" @click="close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Loan Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="loanTypeId" @change="checkLoanTypes">
                      <option>Select Loan Type</option>
                      <option
                        v-for="item in loanTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Amount <span class="text-danger">*</span></label>
                    <input
                      v-model="amount"
                      class="form-control"
                      type="number"
                      :readonly="amountReadonly"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Tenor (per Month)
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="tenor"
                      :max="maxTenor"
                      class="form-control"
                      type="number"
                      :readonly="amountReadonly"
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0">
                    <label
                      >Repayment Amount
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="loan.repaymentAmount"
                      class="form-control"
                      type="number"
                      readonly
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0">
                    <label
                      >Repayment Start Date
                      <span class="text-danger">*</span></label
                    >
                    <datepicker
                      v-model="loan.repaymentStartDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                  <div class="submit-section" v-if="loan.repaymentAmount > 0 || loanType.calculatedRequestAmount">
                    <button
                      class="btn btn-primary submit-btn"
                      :disabled="submitted"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Add Leave Modal -->

          <!-- Edit Leave Modal -->
          <v-dialog v-model="dialogEdit" max-width="500px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Loan Request</h5>
                <button type="button" @click="closeEdit">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updateLoan">
                  <div class="row">
                    <div class="col-md-12">
                      <div
                        class="alert alert-danger alert-dismissible fade show"
                        role="alert"
                        v-if="error"
                      >
                        <strong>Error!</strong> {{ error }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="alert alert-success alert-dismissible fade show"
                        role="alert"
                        v-if="message"
                      >
                        <strong>Success!</strong> {{ message }}
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Loan Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="loan.loanTypeId" @change="checkLoanTypesWithExist">
                      <option>Select Loan Type</option>
                      <option
                        v-for="item in loanTypes"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.description }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-if="!loanType.calculatedRequestAmount">
                    <label>Amount <span class="text-danger">*</span></label>
                    <input
                      v-model="loan.amount"
                      class="form-control"
                      type="number"
                    />
                  </div>
                  <div class="form-group" v-if="!loanType.calculatedRequestAmount">
                    <label
                      >Tenor (per Month)
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="loan.actualTenor"
                      :max="maxTenor"
                      @change="calculateLoan"
                      class="form-control"
                      type="number"
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0 && !loanType.calculatedRequestAmount">
                    <label
                      >Repayment Amount
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="loan.repaymentAmount"
                      class="form-control"
                      type="number"
                      readonly
                    />
                  </div>
                  <div class="form-group" v-if="loan.repaymentAmount > 0 && !loanType.calculatedRequestAmount">
                    <label
                      >Repayment Start Date
                      <span class="text-danger">*</span></label
                    >
                    <datepicker
                      v-model="loan.repaymentStartDate"
                      calendar-class
                      input-class
                      bootstrap-styling
                      class="form-control datetimepicker"
                      type="text"
                    />
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- /Edit Leave Modal -->
          <!-- Delete Leave Modal -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <button type="button" class="close" @click="closeDelete">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3>Delete Loan Request</h3>
                  <p>Are you sure want to delete this loan?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="deleteLoan()"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        @click="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Delete Leave Modal -->
        </div>
        <!-- /Page Wrapper -->
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Datepicker from "vuejs-datepicker";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogStatus: false,
      dialogDelete: false,
      submitted: false,
      media: "data:image/jpeg;base64,",
      headers: [
        { text: "Employee", value: "profile" },
        { text: "Loan Type", value: "loanType.description" },
        { text: "Amount", value: "amount" },
        { text: "Tenor (per month)", value: "actualTenor" },
        { text: "Repayment Amount", value: "repaymentAmount" },
        { text: "Repayment StartDate", value: "repaymentStartDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      loanTypeId: 0,
      amount: 0,
      tenor: 0,
      loan: {},
      loans: [],
      loanType: {},
      loanTypes: [],
      maxTenor: 0,
      amountReadonly: false,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      error: "",
      message: "",
      status: ""
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeEdit();
    },
    tenor(val) {
      if (val > 0 && this.amount > 0 && this.loanTypeId > 0) {
        this.calculateLoan(val);
      }
    },
  },
  computed: {},

  methods: {
    clearModel() {
      this.amount = 0;
      this.tenor = 0;
      this.loanTypeId = 0;
      this.loan.repaymentAmount = "";
      this.loan.repaymentStartDate = "";
      this.submitted = false;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditLoan(item) {
      this.loan = item;
      this.dialogEdit = true;
      // console.log(`item`, item)
    },

    setDeleteLoan(item) {
      this.loan = item;
      this.dialogDelete = true;
    },

    deleteLoan() {
      // const id = this.employeeLeaves.id;
      console.log(this.loan.id);
      employeeService.removeLoanRequest(this.loan.id).then(
        id => {
          employeeService
            .getLoanRequestsByEmployee(this.user.employee.id)
            .then(o => {
              this.loans = o;

              this.dialogDelete = false;
            });
        },
        e => {
          this.error = "Loan is being used in some information";
        }
      );
    },

    setLoan(item) {
      this.loan = item;
    },

    checkLoanTypes() {
      var type = this.loanTypes.find(c => (c.id == this.loanTypeId));
      if (type) {
        if(type.description.toUpperCase().match('CAR')) {
          employeeService.getAmountByLoanType(type.id, this.user.employee.rankId)
          .then(a => {
            this.amount = a; this.tenor = type.tenor;
            this.maxTenor = type.tenor;
            this.loanType = type;
            this.amountReadonly = true;
            this.loan = {id:0, employeeId:0, loanTypeId:type.id, amount: a, actualTenor:type.tenor, repaymentAmount: (a / type.tenor), repaymentStartDate: new Date().toISOString()}
          } )
        } else if (type.description.toUpperCase().match('HOUS')) {
          employeeService.getAmountByLoanType(type.id, this.user.employee.id)
          .then(a => {
            this.amount = a; this.tenor = type.tenor;
            this.maxTenor = type.tenor;
            this.loanType = type;
            this.amountReadonly = true;
            this.loan = {id:0, employeeId:0, loanTypeId:type.id, amount:a, actualTenor:type.tenor, repaymentAmount: (a / type.tenor), repaymentStartDate: new Date().toISOString()}
          } )
        } else {
          this.maxTenor = type.tenor;
          this.loanType = type;
          if(type.calculatedRequestAmount){
            this.loan = {id:0,
              employeeId:0,
              loanTypeId:type.id,
              amount:0,
              actualTenor:0,
              repaymentAmount:0,
              repaymentStartDate:"0001-01-01T00:00:00",
              }
            }
        }
      } else {
        this.maxTenor = 6;
      }
    },
    checkLoanTypesWithExist() {
      this.loanType = this.loanTypes.find(c => c.id == this.loan.loanTypeId);
    },

    updateLoan() {
      this.submitted = true;
      this.loading = true;
      employeeService.updateLoanRequest(this.loan.id, this.loan).then(
        id => {
          employeeService
            .getLoanRequestsByEmployee(this.user.employee.id)
            .then(o => {
              this.loans = o;
              this.closeEdit();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    changeLeaveStatus(status) {
      this.submitted = true;
      const id = this.leave.id;
      this.leave.status = status;
      this.leave.approvedBy = this.user.employee.id;
      this.loading = true;
      employeeService.updateEmployeeLeave(id, this.leave).then(
        id => {
          employeeService.getEmployeeLeaves(this.company.id).then(o => {
            this.employeeLeaves = o;
            this.closeStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getLoans() {
      employeeService.getLoanRequestsByEmployee(this.user.employee.id).then(
        o => {
          this.loans = o;
        },
        error => {
          error = error;
        }
      );
    },
    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;
      this.loading = true;
      this.loan.requestDate = new Date();
      this.loan.employeeId = this.user.employee.id;
      this.loan.loanType = null;
      employeeService.addLoanRequest(this.loan).then(
        id => {
          this.message = "Loan Request Added successfully";
          employeeService
            .getLoanRequestsByEmployee(this.user.employee.id)
            .then(model => {
              this.loans = model;
              this.message = "";
              this.loanTypeId = 0;
              this.close();
            });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    onDownload(loan) {
      this.loading = true
      employeeService.exportCertificate(loan.id, loan.loanTypeId)
      .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
          this.loading = false;
        }).catch((error) => {
            alert(error);
            this.loading = false;
        });
    },
    calculateLoan(tenor) {
      this.submitted = true;
      this.loading = true;
      var loan = {
        loanTypeId: this.loanTypeId,
        amount: this.amount,
        actualTenor: tenor
      };
      employeeService.calculateLoan(loan).then(
        model => {
          this.loan = model;
          this.submitted = false;
          this.loan.repaymentStartDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            new Date().getDate()
          );
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.getLoanTypes();
    this.getLoans();

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "leaves"
};
</script>



// WEBPACK FOOTER //
// src/components/loans/loan/loanRequestHr.vue